import { render, staticRenderFns } from "./AppStreetlamp2.vue?vue&type=template&id=308ef0c5&scoped=true&"
import script from "./AppStreetlamp2.vue?vue&type=script&lang=js&"
export * from "./AppStreetlamp2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308ef0c5",
  null
  
)

export default component.exports